// TODO: try to implementing the good font familly
export function AddingStyleTag()  {
    //let styleTag =`<style>${fontFace}</style>`
    let styleTag= document.createElement('style')
    return styleTag
}
